import { connect } from "react-redux";
import TrendComparison from "./TrendComparison";
import { getProjectComparison, getRaterHeatmap, getSelfVsOthers, getTopStrengthTopDev, handleChangeComparisonToggle, setTrendDataFetched } from "../../../../../../redux/actions";

// Deliberately not subscribed to the filter lookups: whether there's a card to
// draw at all is TrendToggle's business, so those landing re-render the toggle
// and nothing else. See the note in TrendComparison.
const mapStateToProps = (state) => ({
    isTrendComparison: state.BenchmarkFilteringReducer.isTrendComparison,
    benchmarkFiltersAnalysis: state.BenchmarkFilteringReducer.benchmarkFiltersAnalysis,
    isTrendDataFetched: state.BenchmarkFilteringReducer.isTrendDataFetched,
    // The pairing the results are built from, not the one being edited.
    appliedPairing: state.BenchmarkFilteringReducer.trendPairing.applied,
});

const mapDispatchToProps = (dispatch) => ({
    handleChangeComparisonToggle: (payload) => dispatch(handleChangeComparisonToggle(payload)),
    setTrendDataFetched: (payload) => dispatch(setTrendDataFetched(payload)),
    getProjectComparison: (payload) => dispatch((getProjectComparison(payload))),
    getRaterHeatmap: (payload) => dispatch(getRaterHeatmap(payload)),
    getSelfVsOthers: (payload) => dispatch(getSelfVsOthers(payload)),
    getTopStrengthTopDev: (payload) => dispatch(getTopStrengthTopDev(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(TrendComparison);
